/**
 * Check if two given {interval}s overlap
 * Essentially collision detection - are the boundaries of one interval within another
 * where an {interval} = { left:Number, right:Number }
 *
 * @return bool
 */
function isOverlapped(interval1, interval2) {
  return !(interval2.left >= interval1.right || interval1.left >= interval2.right)
}

export default {
  isOverlapped,
}
